// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateEncryptedExternalBankAccountDto
 */
export interface ICreateEncryptedExternalBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof ICreateEncryptedExternalBankAccountDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateEncryptedExternalBankAccountDto
     */
    routing_transit_number: string;
    /**
     * 
     * @type {string}
     * @memberof ICreateEncryptedExternalBankAccountDto
     */
    account_category?: ICreateEncryptedExternalBankAccountDtoAccountCategoryEnum;
    /**
     * 
     * @type {number}
     * @memberof ICreateEncryptedExternalBankAccountDto
     */
    organization_id: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateEncryptedExternalBankAccountDto
     */
    organization_path: string;
    /**
     * 
     * @type {number}
     * @memberof ICreateEncryptedExternalBankAccountDto
     */
    employee_id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateEncryptedExternalBankAccountDto
     */
    external_identifier?: string;
    /**
     * Should be encrypted with RSAES_OAEP_SHA_1 algorithm and encoded in base64 format
     * @type {string}
     * @memberof ICreateEncryptedExternalBankAccountDto
     */
    number?: string;
}

/**
* @export
* @enum {string}
*/
export enum ICreateEncryptedExternalBankAccountDtoAccountCategoryEnum {
    CHECKING = 'CHECKING',
    SAVING = 'SAVING',
    NONE = 'NONE'
}


/**
 * Check if a given object implements the ICreateEncryptedExternalBankAccountDto interface.
 */
export function instanceOfICreateEncryptedExternalBankAccountDto(value: object): value is ICreateEncryptedExternalBankAccountDto {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('routing_transit_number' in value) || value['routing_transit_number'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    if (!('organization_path' in value) || value['organization_path'] === undefined) return false;
    return true;
}

export function ICreateEncryptedExternalBankAccountDtoFromJSON(json: any): ICreateEncryptedExternalBankAccountDto {
    return ICreateEncryptedExternalBankAccountDtoFromJSONTyped(json, false);
}

export function ICreateEncryptedExternalBankAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateEncryptedExternalBankAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'routing_transit_number': json['routing_transit_number'],
        'account_category': json['account_category'] == null ? undefined : json['account_category'],
        'organization_id': json['organization_id'],
        'organization_path': json['organization_path'],
        'employee_id': json['employee_id'] == null ? undefined : json['employee_id'],
        'external_identifier': json['external_identifier'] == null ? undefined : json['external_identifier'],
        'number': json['number'] == null ? undefined : json['number'],
    };
}

export function ICreateEncryptedExternalBankAccountDtoToJSON(json: any): ICreateEncryptedExternalBankAccountDto {
    return ICreateEncryptedExternalBankAccountDtoToJSONTyped(json, false);
}

export function ICreateEncryptedExternalBankAccountDtoToJSONTyped(value?: ICreateEncryptedExternalBankAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'routing_transit_number': value['routing_transit_number'],
        'account_category': value['account_category'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'employee_id': value['employee_id'],
        'external_identifier': value['external_identifier'],
        'number': value['number'],
    };
}

